import sliceCreator from '../../index.jsx';
import {UPDATE_ZONE} from '../../../constants/index.jsx';
const _updateZoneAction = sliceCreator('UPDATE_ZONE', UPDATE_ZONE, 'put');

const { asyncAction: updateZoneAction, reducer, clearData: clearUpdateZoneAction } = _updateZoneAction;

export default reducer;

export {
    updateZoneAction,
    clearUpdateZoneAction
}